import React, { PureComponent } from 'react'
import { translate } from 'react-polyglot'
import { Field, reduxForm } from 'redux-form'
import history from 'configureHistory'

import { Form, Button, Text, Notice, ButtonGroup } from 'components'
import { Email, Password } from 'components/FormField'
import { required, minLength6, email } from 'utils/validation'

class LoginForm extends PureComponent {
	render() {
		const {
			handleSubmit,
			submitting,
			error,
			existingUserInvited,
			loginMessage,
			awaitingVerification,
			awaitingVerificationEmail,
			resentVerification,
			onResendVerification,
			t,
			...props
		} = this.props

		return (
			<div className="u-center-inside-flex u-max-width--small">
				<Form
					onSubmit={handleSubmit}
					actions={
						<ButtonGroup orientation="horizontal">
							<Button
								layout="secondary"
								text={t('forms.sign_in')}
								type="submit"
								disabled={submitting}
							/>
							<Button
								text={t('forgot_password')}
								onClick={() => history.push('/forgot-password')}
							/>
						</ButtonGroup>
					}
					error={error}
				>
					<h1>
						{t('forms.sign_in')}
						<Text size="small">
							{t('or')}&nbsp;
							<Button
								layout="underlined-text"
								text={t('forms.sign_up_new_account')}
								onClick={() => history.push('/register')}
							/>
						</Text>
					</h1>
					{loginMessage.description && (
						<Notice
							title={
								loginMessage.title
									? t(loginMessage.title)
									: null
							}
							text={t(loginMessage.description)}
						/>
					)}
					{awaitingVerification && (
						<Notice
							title={t('forms.email_verification')}
							text={
								<>
									{resentVerification ? (
										<>
											{t(
												'forms.email_resend_verification_text'
											)}
										</>
									) : (
										<>
											{t('forms.email_verification_text')}
											&nbsp;
											<Button
												layout="underlined-text"
												text={t(
													'forms.email_resend_verification_button'
												)}
												onClick={() =>
													onResendVerification(
														awaitingVerificationEmail
													)
												}
											/>
										</>
									)}
								</>
							}
						/>
					)}
					{existingUserInvited && (
						<Notice
							title={t('forms.invitation')}
							text={<>{t('forms.invitation_login_text')}</>}
						/>
					)}
					<Field
						name="email"
						label={t('forms.email')}
						component={Email}
						validate={[required, email]}
						disabled={submitting}
					/>
					<Field
						name="password"
						label={t('forms.password')}
						component={Password}
						validate={[minLength6, required]}
						disabled={submitting}
					/>
				</Form>
			</div>
		)
	}
}

export default reduxForm({
	form: 'login',
})(translate()(LoginForm))
